export function last<TItem>(array: TItem[]): TItem | undefined {
  return array[array.length - 1]
}
